import Ticker from "framer-motion-ticker";
import { useEffect, useState } from "react";
import { HStack, VStack } from "../../../shared/utils";
import { formatToReadableNumber } from "../../../utils/currencyRoboto";
import Tooltip from "../../../shared/Tooltip";
import { globalCompaniesList } from "../../../utils/globalCompanies";
import Loader from "../../../utils/loader";
export type TickerType = {
  logo: string;
  title: string;
  value: number;
  valueLabel?: string;
  className?: string;
  currencySymbol?: string;
  year?: string;
};

export function Tickers({tickerData}: { tickerData: TickerType[]}) {
  const [isHover, setIsHover] = useState<boolean>(false);

  return (
    <Ticker
      duration={60}
      isPlaying={!isHover}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {tickerData?.map((item) => (
        <div
          className="w-[250px] h-[80px] mt-2 bg-white border rounded-lg border-gray-200 hover:border-gray-600 me-4 cursor-pointer hover-effect grid grid-col-4 p-3 hover:bg-activeColor items-center"
          style={{
            boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
          }}
        >
          <HStack className="col-span-4">
            <HStack className="col-span-3 w-[70%] items-center">
              <img
                src={item.logo}
                alt="logo"
                className="w-9 h-9 mr-2 rounded-md"
              />
              <div className="flex flex-col items-start justify-top mb-2">
                <p className="text-sm font-semibold text-gray-800">
                  {item.title}
                </p>
                {/* <p className='text-xs text-gray-500'>{item.}</p> */}
              </div>

              {/* {isHover && <p className='text-xs text-gray-500'>Hovered</p>} */}
            </HStack>
            <VStack className="pl-2">
              <div className="flex flex-col items-center ">
                {/* <Tooltip
                  text={item.value.toLocaleString("en-IN")}
                  position="-bottom-16"
                  _className="z-[100]"
                > */}
                <p
                  className="text-xs font-bold text-center text-gray-800"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={item.value.toLocaleString("en-IN")}
                >
                  {item.currencySymbol}
                  {formatToReadableNumber({
                    value: item.value,
                  })}
                </p>
                {/* </Tooltip> */}
                {/* <p className='text-xs text-gray-500'>{item.}</p> */}
              </div>
              {item.valueLabel && (
                <p className="text-xs text-gray-400">{item.valueLabel}</p>
              )}
              <p className="text-xxs text-gray-400">{item.year}</p>
            </VStack>
          </HStack>
        </div>
      ))}
    </Ticker>
  );
}
